import type { ReactNode } from 'react';
import { Card, Typography } from 'antd';
import { ShopOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

interface Props {
  title: string;
  subtitle?: string;
  children: ReactNode;
  footer?: ReactNode;
  /** Card width — default 400. Form 2 cột (đăng ký) nên truyền 640. */
  width?: number;
}

export function AuthLayout({ title, subtitle, children, footer, width = 400 }: Props) {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f0f2f5',
        padding: 16,
      }}
    >
      <Card style={{ width, maxWidth: '100%' }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <ShopOutlined style={{ fontSize: 36, color: '#a4193d' }} />
          <Title level={3} style={{ marginTop: 8, marginBottom: 4 }}>
            {title}
          </Title>
          {subtitle && <Text type="secondary">{subtitle}</Text>}
        </div>
        {children}
        {footer && <div style={{ marginTop: 16, textAlign: 'center' }}>{footer}</div>}
      </Card>
    </div>
  );
}
